export default class AppConstants {

  public static AUTH_TOKEN = "auth_token_new";
  public static RW_HASH_TOKEN = "rw_hash_token";
  public static JWT_HASH = "jwt_hash";
  public static x_refresh_token = "x_refresh_token";

  public static OFFLINE_FILES = "offline_files";
  public static CHAT_OFFLINE_MESSAGE_QUEUE = "chat_offline_message_queue";

  public static REFRESH_TOKEN = "refresh_token";
  public static ACS_TOKEN = "acs_token";
  public static CHAT_TOKENS = "chat_tokens";
  public static SELECTED_LANGUAGE = "selected_language";
  public static SELECTED_APPEARANCE_THEME = "selected_appearance_theme";
  public static DEFAULT_LANGUAGE = "de";
  public static DEFAULT_APPEARANCE_THEME = "system";
  public static TRANSLATION_PREFIX = 'translations_';
  public static DEVICE_INFO = 'device_info';
  public static APP_VERSION = 'app_version';

  public static GIRD_LAYOUT = 'gird_layout';
  public static USER_DETAILS = 'user_details';
  public static LOGINDATA = 'login_form_backup';

  public static USER_ID = 'user_id';
  public static CHANGE_PASSWORD_STATUS = 'change_password_status';
  public static FAKE_TOKEN = "eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IlV0a2Fyc2hhIiwiaWF0IjoxNTE2MjM5MDIyfQ";

  public static LANGUAGES: LanguageOption[] = [
    { type: 'en', name: 'English', global: 'en' },
    { type: 'de', name: 'Deutsch', global: 'de' },
  ];
}

export interface LanguageOption {
  type: string;
  name: string;
  global: string;
}